import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ChoosePlanComponent } from './views/choose-plan/choose-plan.component';
import { ClientDataComponent } from './views/client-data/client-data.component';
import { ProcessCancellationComponent } from './views/contract-cancellation/process-cancellation/process-cancellation.component';
import { ViewPendingCancellationsComponent } from './views/contract-cancellation/view-pending-cancellations/view-pending-cancellations.component';
import { ContractEditDealerComponent } from './views/contract-dealer/contract-edit-dealer.component';
import { ContractSearchDealerComponent } from './views/contract-dealer/contract-search-dealer.component';
import { ContractManualComponent } from './views/contract-manual/contract-manual.component';
import { ContractSignatureComponent } from './views/contract-signature/contract-signature.component';
import { ContractSummaryAttachmentOneComponent } from './views/contract-summary-attachment-one/contract-summary-attachment-one.component';
import { ContractSummaryAttachmentTwoComponent } from './views/contract-summary-attachment-two/contract-summary-attachment-two.component';
import { ContractSummaryExternalComponent } from './views/contract-summary-external/contract-summary-external.component';
import { ContractSummaryComponent } from './views/contract-summary/contract-summary.component';
import { ContractEditComponent } from './views/contract/contract-edit.component';
import { ContractSearchComponent } from './views/contract/contract-search.component';
import { ReportsComponent } from './views/excel-reports/reports/reports.component';
import { HomeComponent } from './views/home/home.component';
import { ImportContractComponent } from './views/import-contract/import-contract.component';
import { InformationComponent } from './views/information/information.component';
import { LegalTextContractArgentinaComponent } from './views/legal-text-contract/legal-text-contract-argentina/legal-text-contract-argentina.component';
import { LegalTextContractBraDealerReviewsComponent } from './views/legal-text-contract/legal-text-contract-bra-dealer-reviews/legal-text-contract-bra-dealer-reviews.component';
import { DirectSaleComponent } from './views/new-contract-direct-sale/direct-sale.component';
import { NotFoundComponent } from './views/not-found/not-found.component';
import { PaymentMethodComponent } from './views/payment-method/payment-method.component';
import { PaymentSignatureComponent } from './views/payment-signature/payment-signature.component';
import { PlanSelectionComponent } from './views/plan-selection/plan-selection.component';
import { CoverageDetailsEditComponent } from './views/plans-details-edit/coverage-details-edit/coverage-details-edit.component';
import { EligibilityDetailsEditComponent } from './views/plans-details-edit/eligibility-details-edit/eligibility-details-edit.component';
import { PriceDetailsEditComponent } from './views/plans-details-edit/price-details-edit/price-details-edit.component';
import { ProductDetailsEditComponent } from './views/plans-details-edit/product-details-edit/product-details-edit.component';
import { NewCoverageComponent } from './views/product-create-search/new-coverage/new-coverage.component';
import { NewEligibilityComponent } from './views/product-create-search/new-eligibility/new-eligibility.component';
import { NewPriceComponent } from './views/product-create-search/new-price/new-price.component';
import { NewProductComponent } from './views/product-create-search/new-product/new-product.component';
import { ViewPlansComponent } from './views/product-create-search/view-plans/view-plans.component';
import { SalesChannelExternalComponent } from './views/sales-channel-external/sales-channel-external.component';
import { SalesChannelComponent } from './views/sales-channel/sales-channel.component';
import { VehicleInformationComponent } from './views/vehicle-information/vehicle-information.component';
import { LegalTextContractMaintenanceArgentinaComponent } from './views/legal-text-contract/legal-text-contract-maintenance-argentina/legal-text-contract-maintenance-argentina.component';

const routes: Routes = [
	
	{
		path: '',
		redirectTo: 'home',
		pathMatch: 'full'
	},
	{
		path: 'home',
		component: HomeComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'direct-sale',
		component: DirectSaleComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'import-contract',
		component: ImportContractComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'plan-selection',
		component: PlanSelectionComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'sales-channel',
		component: SalesChannelComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'view-plans',
		component: ViewPlansComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'reports',
		component: ReportsComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'new-coverage',
		component: NewCoverageComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'new-eligibility',
		component: NewEligibilityComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'new-price',
		component: NewPriceComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'new-product',
		component: NewProductComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'coverage-details-edit/:id',
		component: CoverageDetailsEditComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'eligibility-details-edit/:id',
		component: EligibilityDetailsEditComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'price-details-edit/:id',
		component: PriceDetailsEditComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'product-details-edit/:id',
		component: ProductDetailsEditComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'sales-channel-external',
		component: SalesChannelExternalComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'vehicle-information/:saleChannel',
		component: VehicleInformationComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'choose-plan/:saleChannel',
		component: ChoosePlanComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'client-data/:saleChannel',
		component: ClientDataComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'contract-summary/:saleChannel',
		component: ContractSummaryComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'contract-summary-external/:saleChannel',
		component: ContractSummaryExternalComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'contract-summary-attachment-one/:saleChannel',
		component: ContractSummaryAttachmentOneComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'contract-summary-attachment-two/:saleChannel',
		component: ContractSummaryAttachmentTwoComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'legal-text-contract-argentina/:saleChannel',
		component: LegalTextContractArgentinaComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'legal-text-contract-maintenance-argentina/:saleChannel',
		component: LegalTextContractMaintenanceArgentinaComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'legal-text-contract-bra-dealer-reviews/:saleChannel',
		component: LegalTextContractBraDealerReviewsComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'contract-search',
		component: ContractSearchComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'contract-search-dealer',
		component: ContractSearchDealerComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'contract-manual',
		component: ContractManualComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'payment-method',
		component: PaymentMethodComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'payment-signature',
		component: PaymentSignatureComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'contract-signature',
		component: ContractSignatureComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'contract-edit',
		component: ContractEditComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'contract-edit-dealer',
		component: ContractEditDealerComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'information',
		component: InformationComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'view-pending-cancellations',
		component: ViewPendingCancellationsComponent,
		canActivate: [MsalGuard]
	},
	{
		path: 'process-cancellation/:contractNumber',
		component: ProcessCancellationComponent,
		canActivate: [MsalGuard]
	},
	{
		path: '404',
		component: NotFoundComponent,
		canActivate: [MsalGuard]
	},
	{
		path: '**',
		redirectTo: '/404'
	}

];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: false, scrollPositionRestoration: 'top' })],
	exports: [RouterModule]
})

export class AppRoutingModule {
}
